export interface AccountBalanceNotifyConfig {
  condition: 'GT' | 'LT';
  amount: number;
}

export const AccountBalanceNotifyConditions = ['GT', 'LT'] as AccountBalanceNotifyConfig['condition'][];